import { createFileRoute } from '@tanstack/react-router'
import { AttributesPage } from '@/features/attributes'

export const Route = createFileRoute('/_authenticated/attributes/')({
  component: AttributesPage,
})
